export default __webpack_public_path__ + "static/media/ideasEmpty.3540d889.jpg";